import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { FiMic } from 'react-icons/fi';

// Free voice trial: the code step and the call run on the chat service's own origin
// (backend/unified_api/voice_trial.py), so the site only opens it in a frame. The same page is
// reachable as <any site page>#voice-trial, a link sales can send. Our addition, not the business
// team's copy: re-add this file and its two buttons in LandingPage after a site delivery.
const CHAT_ORIGIN = 'https://aiker-chat-public-663426938258.us-west2.run.app';
const LABEL = { zh: '免费试用语音通话（内测）', en: 'Free voice trial (beta)' };
const HASH = '#voice-trial';

export default function VoiceTrialButton({ lang, ...buttonProps }) {
  const [open, setOpen] = useState(false);
  const zh = lang === 'zh';

  useEffect(() => {
    if (window.location.hash === HASH) setOpen(true);
  }, []);

  return (
    <>
      <Button variant="outline" leftIcon={<FiMic />} onClick={() => setOpen(true)} {...buttonProps}>
        {zh ? LABEL.zh : LABEL.en}
      </Button>
      <Modal isOpen={open} onClose={() => setOpen(false)} isCentered size={{ base: 'full', md: 'md' }}>
        <ModalOverlay />
        <ModalContent overflow="hidden">
          <ModalCloseButton zIndex={1} />
          <ModalBody p={0}>
            {open && (
              <iframe
                title={zh ? LABEL.zh : LABEL.en}
                src={`${CHAT_ORIGIN}/voice-trial?lang=${zh ? 'zh' : 'en'}`}
                allow="microphone"
                referrerPolicy="origin"
                style={{ display: 'block', width: '100%', height: 'min(560px, 100dvh)', border: 'none' }}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
